// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAo8OR345eyve9291aMfKn7chsnw8swQoM",
  authDomain: "wenergie-21499.firebaseapp.com",
  projectId: "wenergie-21499",
  storageBucket: "wenergie-21499.appspot.com",
  messagingSenderId: "288956989920",
  appId: "1:288956989920:web:b27040f7b9e8e7156feb85",
  measurementId: "G-RP28CP6QH0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);

export { analytics };
